<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2018 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2018</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">27 26 25 24 23 22 21 20 19 18    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-53832-7 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-53846-4 (paper)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-53863-1 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226538631.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226538631.001.0001</a></p>
<p class="crtf"><img alt="" height="64" src="images/logo-MBL.jpg" width="300"/></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Minteer, Ben A., 1969– editor. | Maienschein, Jane, editor. | Collins, James P., editor.</p>
<p class="cip">Title: The ark and beyond : the evolution of zoo and aquarium conservation / edited by Ben A. Minteer, Jane Maienschein, and James P. Collins.</p>
<p class="cip">Other titles: Convening science.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2018. | Series: Convening science</p>
<p class="cip">Identifiers: <span class="sm">LCCN</span> 2017042866 | <span class="sm">ISBN</span> 9780226538327 (cloth : alk. paper) | <span class="sm">ISBN</span> 9780226538464 (pbk. : alk. paper) | <span class="sm">ISBN</span> 9780226538631 (e-book)</p>
<p class="cip">Subjects: <span class="sm">LCSH</span>: Zoos. | Aquariums. | Conservation biology.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">QL</span>76 .<span class="sm">A</span>75 2018 | <span class="sm">DDC</span> 590.73—dc23 <span class="sm">LC</span> record available at <a class="url" href="https://lccn.loc.gov/2017042866" target="_blank">https://lccn.loc.gov/2017042866</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ansi/niso z39.48–1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-minteer-0005.vue?69fc92f6